"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.FacetFilter = void 0;
var _icons = require("@ori-ui/icons");
var _mui = require("@ori-ui/mui");
var _presentationHooks = require("@ori/presentation-hooks");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _utils = require("../../utils");
var _FacetFilterCategory = require("../FacetFilterCategory/FacetFilterCategory");
var _FilterWindow = require("../FilterWindow");
var _Loading = require("./components/Loading");
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const FacetFilter = (param)=>{
    let { title, onSubmit, value: defaultValues, settings, onChange, onClose: onCloseProp, isLoading = false } = param;
    const { getTestId } = (0, _testidGenerator.default)();
    const { onToggle, onClose: onCloseDropdown, open, onOpen } = (0, _presentationHooks.useDisclose)();
    const [value, setValue] = (0, _react.useState)(defaultValues);
    const [openedCategory, setOpenedCategory] = (0, _react.useState)(null);
    const categoryRefs = (0, _react.useMemo)(()=>value === null || value === void 0 ? void 0 : value.reduce((acc, category)=>({
                ...acc,
                [category.key]: /*#__PURE__*/ (0, _react.createRef)()
            }), {}), [
        value
    ]);
    (0, _react.useEffect)(()=>{
        setValue(defaultValues);
    }, [
        defaultValues
    ]);
    const onFilterClick = (0, _react.useCallback)((event)=>{
        event.stopPropagation();
        onToggle();
    }, [
        onToggle
    ]);
    const close = (0, _react.useCallback)(()=>{
        onCloseDropdown();
        setOpenedCategory(null);
    }, [
        onCloseDropdown
    ]);
    const onClose = (0, _react.useCallback)(()=>{
        close();
        onCloseProp === null || onCloseProp === void 0 ? void 0 : onCloseProp();
    }, [
        close,
        onCloseProp
    ]);
    const onShortcut = (0, _react.useCallback)((event)=>{
        event.preventDefault();
        onOpen();
    }, [
        onOpen
    ]);
    (0, _utils.useMousetrap)([
        'command+shift+ctrl+f',
        'ctrl+shift+alt+f'
    ], onShortcut);
    const onOptionClick = (0, _react.useCallback)((category, optionValue)=>{
        const updatedValue = value === null || value === void 0 ? void 0 : value.map((faceFilterValue)=>{
            if (faceFilterValue.key === category) {
                const updatedItems = faceFilterValue.items.map((item)=>item.value === optionValue ? {
                        ...item,
                        selected: !item.selected
                    } : item);
                return {
                    ...faceFilterValue,
                    items: updatedItems
                };
            }
            return faceFilterValue;
        });
        onChange === null || onChange === void 0 ? void 0 : onChange(updatedValue !== null && updatedValue !== void 0 ? updatedValue : []);
    }, [
        onChange,
        value
    ]);
    const onClear = (0, _react.useCallback)(()=>{
        const clearedValue = value === null || value === void 0 ? void 0 : value.map((faceFilterValue)=>({
                ...faceFilterValue,
                items: faceFilterValue.items.map((item)=>({
                        ...item,
                        selected: false
                    }))
            }));
        onChange === null || onChange === void 0 ? void 0 : onChange(clearedValue !== null && clearedValue !== void 0 ? clearedValue : []);
        close();
        onSubmit(clearedValue !== null && clearedValue !== void 0 ? clearedValue : []);
    }, [
        onChange,
        close,
        value,
        onSubmit
    ]);
    const onCategoryClick = (0, _react.useCallback)((category)=>{
        if (openedCategory === category) {
            setOpenedCategory(null);
        } else {
            setOpenedCategory(category);
        // TODO -- make this work on scrollable page without scrolling the whole page
        // categoryRefs?.[category]?.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
    }, [
        openedCategory
    ]);
    const onSubmitInternal = (0, _react.useCallback)(()=>{
        onSubmit(value !== null && value !== void 0 ? value : []);
        close();
    }, [
        onSubmit,
        value,
        close
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_styles.FilterButton, {
                "data-testid": getTestId(_constants.FACET_FILTER_BUTTON),
                onClick: onFilterClick,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_icons.Filter, {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.Typography, {
                        fontWeight: "bold",
                        color: "textPrimary",
                        textTransform: "uppercase",
                        children: title
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_FilterWindow.FilterWindow, {
                settings: settings,
                isOpen: open,
                title: title,
                onClose: onClose,
                onClear: onClear,
                onSubmit: onSubmitInternal,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_styles.Content, {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)(_Loading.Loading, {
                            isLoading: isLoading
                        }),
                        value === null || value === void 0 ? void 0 : value.map((category, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(_FacetFilterCategory.FacetFilterCategory, {
                                category: category,
                                openedCategory: openedCategory,
                                categoryRef: categoryRefs === null || categoryRefs === void 0 ? void 0 : categoryRefs[category.key],
                                isFirst: index === 0,
                                onCategoryClick: onCategoryClick,
                                onOptionClick: onOptionClick
                            }, category.key))
                    ]
                })
            })
        ]
    });
};
exports.FacetFilter = FacetFilter;
